import axios from "axios";
import { v4 as uuid } from "uuid";

import { auth } from "@/auth";
import store from "@/store/root";
import { Document, Session, Token } from "@/tools/msa/models";
import { Response } from "@/tools/msa/models/requests/tokenisation";

export const tokeniseDocument = async (
  document: Document,
  session: Session
): Promise<Document> => {
  let documentIndex = 0;

  return await axios
    .post<Response>(
      (store.state as any).settings.current.endpoints.tokenizer,
      {
        sections: document.pages.map(page => page.text)
      },
      { headers: await auth.headers() }
    )
    .then(response => response.data)
    .then(tokensPerPage =>
      tokensPerPage.map((tokens, page) =>
        tokens.map(
          (token, index, tokens): Token => {
            return Object.freeze({
              id: uuid(),
              text: token.value.replaceAll("\\n", "\n").replaceAll("\\t", "\t"),
              delimiter:
                index < tokens.length - 1
                  ? document.pages[page].text
                      .substring(token.span[1], tokens[index + 1].span[0])
                      .replaceAll("\\n", "\n")
                      .replaceAll("\\t", "\t")
                  : "",
              occurrences: [
                {
                  source: "document",
                  index: documentIndex++,
                  document
                },
                {
                  source: "page",
                  page: document.pages[page],
                  index
                }
              ]
            });
          }
        )
      )
    )
    .then(tokensPerPage => {
      document.tokens = tokensPerPage.flat(1);

      document.pages.forEach((page, index) => {
        page.tokens = tokensPerPage[index];
        page.sections = [
          {
            id: uuid(),
            page,
            tokens: page.tokens,
            included: null
          }
        ];
      });

      return document;
    });
};
